const API_ORIGIN = process.env.REACT_APP_API_ORIGIN || "http://127.0.0.1:8000";

function normaliseImage(src) {
  if (!src) return "/images/tazy-transport-truck.jpg";
  if (src.startsWith("http://") || src.startsWith("https://") || src.startsWith("/images/")) return src;
  if (src.startsWith("/media/")) return `${API_ORIGIN}${src}`;
  if (src.startsWith("media/")) return `${API_ORIGIN}/${src}`;
  return src;
}

function formatAreas(service) {
  const areas = Array.isArray(service.service_areas) ? service.service_areas : [];
  if (areas.length) return areas.slice(0, 3).join(" • ");
  return service.base_city || service.base_province || "Service areas available";
}

function formatPrice(service) {
  const value = Number(service.base_price || 0);
  if (!value) return "Quote based";
  return `From US$${value.toFixed(2)}`;
}

export default function TransporterServiceCard({ service, onSelect, compact = false }) {
  const image = normaliseImage(service.image_src || service.image_url);
  return (
    <article className={`transport-service-card ${compact ? "transport-service-card--compact" : ""}`}>
      <div className="transport-service-card__image">
        <img src={image} alt={service.service_name || service.courier_name || "Transport service"} loading="lazy" />
        <span>{service.service_type?.replaceAll("_", " ") || "Delivery"}</span>
      </div>
      <div className="transport-service-card__body">
        <div className="transport-service-card__top">
          <h3>{service.service_name}</h3>
          <strong>{formatPrice(service)}</strong>
        </div>
        <p>{service.price_notes || "Registered transporter service available for marketplace deliveries."}</p>
        <div className="transport-service-meta">
          <span>{service.courier_name || "Transporter"}</span>
          <span>{formatAreas(service)}</span>
        </div>
        <div className="marketplace-rating-line">{Number(service.courier_review_count || 0) ? <><span>★</span><strong>{Number(service.courier_rating || 0).toFixed(1)}</strong><em>({service.courier_review_count} delivery reviews)</em></> : <em>New transporter</em>}</div>
        <div className="transport-service-actions">
          {onSelect ? <button type="button" onClick={() => onSelect(service)}>Choose service</button> : null}
        </div>
      </div>
    </article>
  );
}
